import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import { toast } from "react-toastify";
import DataTable from "../../component/DataTable";
import AdminHeader from "../../component/AdminHeader";

const authorEditPath = "edit-client-logo";
const ListEndpoint = ApiEndpoints.clientLogo.List;
const DeleteEndpoint = ApiEndpoints.clientLogo.Delete;
const tableHeader = ["Logo", "Status"];
const tbody = ["logo", "status"];

export default function ClientLogos() {

  const [data, setData] = useState([]);

  useEffect(() => {
    const dataFetch = async () => {
      try {
        const response = await ApiRequest("GET", ListEndpoint);
        const result = response.logos;
        setData(result);
      } catch (error) {
        console.log(error);
      }
    };
    dataFetch();
  }, []);

  const handleDelete = useCallback(
    async (logo_id) => {
      const payload = { logo_id };
      try {
        await ApiRequest("POST", DeleteEndpoint, payload);
        toast.success("Logo deleted successfully");
        setData((prevData) => prevData.filter((item) => item._id !== logo_id));
      } catch (error) {
        console.error("Error deleting author:", error);
      }
    },
    []
  );

  const pagename = {
    name: 'Logo Management',
    user: 'Admin',
    innerpage: 'Logo Management / Client Logos'
  }

  return (
    <>
      <AdminHeader pagename={pagename} />
      <div className="add-btn-section">
        <Link className="admin-add-btn" to="/add-client-logo">Add +</Link>
        <DataTable
          data={data}
          tableHeader={tableHeader}
          tbody={tbody}
          editPath={authorEditPath}
          onDelete={handleDelete}
        />
      </div>
    </>
  );
}
